const en = {
  brand: "Banh Bao Admin",
  tagline: "Internal management for steamed bun shop",
  nav: {
    dashboard: "Dashboard",
    orders: "Orders",
    products: "Products",
    materials: "Materials",
    production: "Warehouse",
    stockIn: "Stock In",
    customers: "Customers",
    customerCare: "Customer Care",
    insights: "AI Insights",
    suppliers: "Suppliers",
    debts: "Debts",
    delivery: "Delivery",
    users: "Staff",
    reports: "Reports",
    finance: "Income & Profit",
    settings: "Settings",
  },
  common: {
    search: "Search...",
    add: "Add new", edit: "Edit", delete: "Delete", cancel: "Cancel", save: "Save",
    confirm: "Confirm", actions: "Actions", yes: "Yes", no: "No",
    loading: "Loading...", empty: "No data", saved: "Saved", deleted: "Deleted",
    error: "Something went wrong", today: "Today", total: "Total",
    name: "Name", phone: "Phone", email: "Email", address: "Address",
    district: "District", city: "City", status: "Status", quantity: "Quantity",
    price: "Price", notes: "Notes", close: "Close", back: "Back",
    update: "Update", create: "Create", filter: "Filter", all: "All",
    logout: "Logout", welcome: "Welcome", language: "Language",
    import: "Import", export: "Export", template: "Download template",
    sort: "Sort", ascending: "Ascending", descending: "Descending",
    print: "Print", pdf: "Export PDF", duplicate: "Duplicate", copy: "Copy", reBuy: "Reorder",
  },
  auth: {
    login: "Sign in", loginTitle: "Sign in",
    loginSubtitle: "Run your steamed bun shop with ease",
    password: "Password", forgot: "Forgot password?",
    or: "or", googleLogin: "Continue with Google", submit: "Sign in",
    invalid: "Invalid email or password",
  },
  dashboard: {
    title: "Dashboard", subtitle: "Today's business summary",
    todayRevenue: "Today's revenue", todayOrders: "Today's orders",
    totalDebt: "Outstanding debt", totalProducts: "Products",
    revenueChart: "Revenue last 7 days", lowStock: "Low stock alerts",
    recentOrders: "Recent orders", topProducts: "Best sellers",
    quickActions: "Quick actions", newOrder: "New order",
    sold: "Sold", inStock: "In stock",
    inactiveCustomers: "Inactive 14+ days", lowStockMaterials: "Low materials",
    serverTime: "Server time",
  },
  orders: {
    title: "Orders", new: "Create order", code: "Code", customer: "Customer",
    items: "Items", total: "Total", date: "Date", dueDate: "Due date",
    payment: "Payment", type: "Type", timeline: "Status timeline",
    addItem: "Add item", selectCustomer: "Select customer", selectProduct: "Select product",
    subtotal: "Subtotal", discount: "Discount", shipping: "Shipping fee",
    paid: "Paid", unpaid: "Unpaid", partiallyPaid: "Partial",
    detail: "Order detail", updateStatus: "Update status", statusNote: "Status note",
    shipper: "Shipper", assignShipper: "Assign shipper",
    retail: "Retail", wholesale: "Wholesale", delivery: "Delivery", duplicate: "Duplicate",
  },
  status: {
    new: "New", processing: "Processing", preparing: "Preparing",
    delivering: "Delivering", delivered: "Delivered",
    debt_pending: "Debt pending", cancelled: "Cancelled",
  },
  payment: {
    cash: "Cash", transfer: "Transfer", debt: "Debt", cod: "Debt",
    ewallet: "E-wallet", card: "Card",
  },
  products: {
    title: "Products", name: "Product name", sku: "SKU", category: "Category",
    description: "Description", cost: "Cost", wholesalePrice: "Wholesale price",
    stock: "Stock", lowStockThreshold: "Low stock threshold",
    unit: "Unit", image: "Image", active: "Active", inactive: "Inactive",
    lowStockOnly: "Low stock only",
  },
  materials: {
    title: "Raw materials", new: "New material", name: "Material name", code: "Code",
    expirationDays: "Default shelf life (days)", productionDate: "Production date",
    expirationDate: "Expiration date", batch: "Batch",
  },
  stock: {
    in: "Stock in", out: "Stock out", adjust: "Adjust", movements: "Movements",
    expiring: "Expiring soon", reason: "Reason",
    reasons: { damage: "Damage", waste: "Waste", lost: "Lost", correction: "Correction", expired: "Expired", other: "Other" },
  },
  customers: {
    title: "Customers", titleSupplier: "Suppliers", code: "Code", nickname: "Nickname",
    group: "Group", vip: "VIP", regular: "Regular", new: "New",
    totalOrders: "Orders", totalSpent: "Spent", rating: "Rating",
    type: "Type", retail: "Retail", wholesale: "Wholesale",
    taxId: "Tax/ID", classification: "Classification", assignedUser: "Assigned",
    maxDebtDays: "Max debt days", maxDebtAmount: "Max debt amount",
    needsCare: "Needs care", lastOrder: "Last order", neverOrdered: "Never ordered",
    careTitle: "Customer care", importExcel: "Import Excel", exportExcel: "Export Excel",
    downloadTemplate: "Download template", importResult: "Import result",
  },
  debts: {
    title: "Debts", customerDebts: "Customer debts", supplierDebts: "Supplier debts",
    totalDebt: "Total debt", overdue: "Overdue", dueSoon: "Due soon", paid: "Paid",
    collect: "Collect", payToSupplier: "Pay supplier",
    paymentHistory: "Payment history", daysToDue: "Days to due",
    daysOverdue: "Days overdue", amount: "Amount", method: "Method", remind: "Remind",
  },
  delivery: {
    title: "Delivery", shifts: "Shifts", morning: "Morning", afternoon: "Afternoon",
    evening: "Evening", night: "Night", assign: "Assign", route: "Route",
    deliveryBill: "Delivery bill",
  },
  users: {
    title: "Staff management", role: "Role", admin: "Admin", manager: "Manager",
    coordinator: "Coordinator", warehouse: "Warehouse", accountant: "Accountant",
    shipper: "Shipper", staff: "Staff",
    newPassword: "New password", paymentMethod: "Payment method",
    permissions: "Permissions", customPermissions: "Custom permissions",
    useDefault: "Use role default", active: "Active", inactive: "Locked",
  },
  reports: {
    title: "Reports & Analytics", revenue: "Revenue report", debt: "Debt report",
    inventory: "Inventory report", daily: "Daily", weekly: "Weekly", monthly: "Monthly",
    totalValue: "Stock value", outOfStock: "Out of stock",
    debtAmount: "Debt amount", lastOrder: "Last order",
  },
  chat: {
    title: "Bao Assistant", subtitle: "Ask me anything",
    placeholder: "Ask about orders, inventory, revenue...",
    send: "Send", thinking: "Thinking...",
    welcome: "Hi! I'm Bao, your internal AI assistant.",
    suggestions: ["Today's revenue?", "Low-stock products?", "Customers inactive 14+ days?"],
    model: "AI model",
  },
  settings: {
    title: "System settings", company: "Company info", bill: "Bill settings",
    integrations: "Integrations", backup: "Backup & Security",
    companyName: "Shop name", description: "Description",
    languageDefault: "Default language", website: "Website", taxId: "Tax ID",
    bankInfo: "Bank info", bankName: "Bank name", bankAccount: "Bank account",
    bankAccountHolder: "Account holder", logo: "Shop logo",
    billShow: "Show on bill", billFooter: "Bill footer",
    resetDemoTitle: "Reset all data",
    resetDemoConfirm: "This will DELETE ALL orders, customers, products, suppliers. Cannot undo.",
    serverTime: "Server time",
  },
};

export default en;
